var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileDislike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.314 17.931c.703-2.248 1.271-5.108 1.271-5.108s-2.375.048-4.489.054h-.745c-.966-.003-1.8-.017-2.209-.054-.62-.055-1-.772-1-.772s-.32-1.919 0-3.647c.196-1.058.61-1.984.793-2.586C1.773 3.068 3.712.02 3.712.02L14.63 0 15.8 2.044V12.33l-6.622 7.134s-2.274-.223-1.864-1.533m10.468-6.05V0h3.97v11.881z"
})));
export default SvgYoutubeMobileDislike;